import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { usePeriodReportBuilder } from "../../hooks/usePeriodReportBuilder";
import { PeriodSelector } from "../PeriodSelector/PeriodSelector";
import { PeriodReportTable } from "../PeriodReportTable/PeriodReportTable";
import { clearReport } from "../../slices/periodReportSlice";

const ProfitAndLossBuilder: React.FC = () => {
  const dispatch = useDispatch();
  const {
    startKey,
    endKey,
    setStartKey,
    setEndKey,
    startMonthOptions,
    endMonthOptions,
    resolvedRange,
    report,
    loading,
    error,
    handleGenerateReport,
    canGenerate,
  } = usePeriodReportBuilder();

  useEffect(() => {
    dispatch(clearReport());
  }, [dispatch]);

  return (
    <MainPageWrapper error={error} title="Profit and Loss Report">
      <div className="space-y-6">
        <PeriodSelector
          canGenerate={canGenerate}
          endKey={endKey}
          endMonthOptions={endMonthOptions}
          loading={loading}
          onEndKeyChange={setEndKey}
          onGenerateReport={handleGenerateReport}
          onStartKeyChange={setStartKey}
          resolvedRange={resolvedRange}
          startKey={startKey}
          startMonthOptions={startMonthOptions}
        />

        {loading && (
          <div className="text-center py-8">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
            <p className="mt-2 text-gray-600">Loading report...</p>
          </div>
        )}

        {!loading && report && <PeriodReportTable report={report} />}

        {!loading && !report && !error && (
          <div className="text-center py-8 text-gray-500">
            Select a date range and click Generate Report to view data.
          </div>
        )}
      </div>
    </MainPageWrapper>
  );
};

export default ProfitAndLossBuilder;
